(function () {
    'use strict';

    angular
        .module('app')
        .directive('rfPopup', rfPopup);

    rfPopup.$inject = ['$window', 'requiredFieldsService', 'loginService'];

    function rfPopup($window, requiredFieldsService, loginService) {
        // Usage:
        //     <rf-popup></rf-popup>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/requiredfields/templates/requiredfields.html',
        };
        return directive;

        function link(scope, element, attrs) {
            scope.service = requiredFieldsService;
            scope.service.showPopup = false;
            scope.loginService = loginService;
        }
    }

})();